import Api from './../api'

const capitalize = str => str.charAt(0).toUpperCase() + str.slice(1)

export default DataLayer => DataLayer.$extend('favorites', {
    async list({ type, membersId, offset, limit = 30, order }) {
        if (!['mixes', 'artists', 'shows', 'genres'].includes(type)) {
            throw new Error('Invalid type')
        }

        const response = await Api.favorites.get({ type, membersId, offset, limit, order })
        return {
            ...response,
            meta: { model: `Favorite${capitalize(type)}` },
            body: (response.body || []).map(item => ({
                ...item,
                id: item[`${type}_id`] && item[`${type}_id`].id,
            })),
        }
    },
    add({ type, membersId, id }) {
        const payload = {
            members_id: {
                id: membersId,
            },
            [`${type}_id`]: {
                id,
            }
        }
        return Api.favorites.post({ type, membersId, id }, payload)
    },
    remove({ type, membersId, id }) {
        return Api.favorites.delete({ type, membersId, id })
    },
})
